import { IntegrationResponse } from '@kcftech/prometheustypescriptapiclient';
import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

const queryKey = 'integration';

export function useIntegration(integrationId: string, locationId: string) {
    return useQuery<IntegrationResponse | undefined, Partial<Error>>({
        queryKey: [queryKey, locationId, integrationId],

        queryFn: async () => {
            const response = await sdClient.getIntegrationForLocation({
                id: locationId,
                integrationId,
            });
            if (response.IsDeleted) {
                return undefined;
            }
            return response;
        },
    });
}

export function invalidateIntegration(integrationId: string, locationId: string) {
    queryClient.invalidateQueries({
        queryKey: [queryKey, locationId, integrationId],
    });
}
